import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import Link from 'next/link';

import Modal from 'components/modals/Modal';
import { PaymentContext } from 'contexts/paymentContext';
import maskAmount from 'utils/maskAmount';

const HowToAuctionWorkModal = ({ visible, setVisible }) => {
  const { paymentData } = useContext(PaymentContext);

  return (
    <Modal
      visible={visible}
      setVisible={setVisible}
    >
      <div className="modal-content">
        <div className="modal-header">
          <div className="modal-title">
            <div className="fs-18 fw-900">Açık Artırma Teklifi Nasıl Verilir?</div>
          </div>
        </div>
        <div className="modal-body">
          <p>
            1- Satın almak istediğiniz iş makinasının marka, model ve ekspertiz raporlarını inceleyin.
          </p>
          <p>
            2- Online açık artırma teklifi verebilmek için ücretsiz üye olun.
          </p>
          <p>
            3- Makinanın ilan sayfasında istediğiniz teklifi yazın ve “Teklif Ver” butonuna basın.
          </p>
          <p>
            4- Teklifinizi işleme alabilmemiz için Teminat Bedelini ödeyin.
          </p>
          <p>
            5- Teklifinizi alıcıya iletelim, 2 gün içerisinde olumlu/olumsuz olarak size dönüş yapalım.
          </p>
          <p>
            6- Teklifiniz kabul edildiği takdirde tüm işlemleri hızlıca halledelim. Makinayı sorunsuz teslim alın.
          </p>
          <div className="modal-title mb-2 mt-4">
            <div className="fs-16 fw-900">Teminat Bedeli Hakkında</div>
          </div>
          <p className="mt-1">
            Satın almak istediğiniz makinalara online teklif verebilmek için öncelikle
            {' '}
            {maskAmount(paymentData.depositAmount, 'TRY')}
            {' '}
            teminat bedelini aktif hale getirmeniz gerekmektedir. Ödemeyi kredi kartı veya havale ile yapabilirsiniz.
            {' '}
            <Link href="/profile/summary">Buraya tıklayarak</Link>
            {' '}
            profil ayarlarına gidebilir, ödemenizi aktif hale getirebilirsiniz.
          </p>
          <p>
            *Teminat bedelini istediğiniz zaman kesintisiz iade alabilirsiniz.
          </p>
          <p>
            *Aynı teminat bedeli ile birden fazla makinaya teklif verebilirsiniz.
          </p>
        </div>

        {/*  <div class="modal-footer modal-footer-sticky">
                footer
            </div> */}
      </div>
    </Modal>
  );
};

HowToAuctionWorkModal.propTypes = {
  visible: PropTypes.bool,
  setVisible: PropTypes.func,
};

export default HowToAuctionWorkModal;
